import React, { useEffect } from "react";

export function Comments({ article }) {
  useEffect(() => {
    if (!article?.id || !article?.url) return;

    window.disqus_config = function () {
      this.page.url = article.url;
      this.page.identifier = article.id;
      this.page.title = article.title;
      this.language = "en_US";
    };

    if (window.DISQUS) {
      window.DISQUS.reset({
        reload: true,
        config: window.disqus_config,
      });
      return;
    }

    const existingScript = document.querySelector(
      'script[src="https://ioonicu.disqus.com/embed.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://ioonicu.disqus.com/embed.js";
      script.setAttribute("data-timestamp", String(Date.now()));
      script.async = true;
      document.body.appendChild(script);
    }
  }, [article.id, article.url, article.title]);

  return <div id="disqus_thread" />;
}